import NewApplicationMatches from '../../../../components/new-application/common/matches';
import { ReviewStatus } from '../../types';
import useApplicationMatches from '../hooks/use-application-matches';
import { ApplicationMatchesTypes } from '../types';

const ApplicationMatches = ({
  applicationType,
  applicationId,
  newApplicationInfo,
  setMatchSelected,
  setDuplicatesCollapsed,
  duplicatesCollapsed,
}: ApplicationMatchesTypes) => {
  const {
    selectedApplicationsArray,
    setSelectedApplicationsArray,
    comment,
    setComment,
    isLoading,
    changeReviewStatus,
    skipMatchesAction,
  } = useApplicationMatches({
    matches: newApplicationInfo?.similarApplications?.edges,
    applicationType,
    applicationId,
    reviewDuplicatesComment: newApplicationInfo?.reviewDuplicatesComment,
  });

  return (
    <NewApplicationMatches
      matches={newApplicationInfo?.similarApplications?.edges}

      setMatchSelected={setMatchSelected}
      collapsed={duplicatesCollapsed}
      setCollapsed={setDuplicatesCollapsed}
      reviewedDuplicates={newApplicationInfo?.reviewedDuplicates}
      reviewStatus={newApplicationInfo?.reviewStatus}
      selectedApplicationsArray={selectedApplicationsArray}
      setSelectedApplicationsArray={setSelectedApplicationsArray}
      comment={comment}
      setComment={setComment}
      isLoading={isLoading}
      changeReviewStatus={changeReviewStatus}
      skipMatchesAction={skipMatchesAction}
      disabled={newApplicationInfo?.reviewStatus !== ReviewStatus.HAS_DUPLICATE}
    />
  );
};

export default ApplicationMatches;
